import {Controller} from '@hotwired/stimulus'

// Keeps a server-rendered row count in sync as rows are appended to (or removed from) a list.
export default class extends Controller {
  static targets = ['rows', 'count']
  static values = {rowSelector: String}

  connect() {
    this.observer = new MutationObserver(() => this.update())
    this.observer.observe(this.rowsTarget, {childList: true, subtree: true})
  }

  disconnect() {
    this.observer.disconnect()
  }

  update() {
    this.countTarget.textContent = String(this.rowsTarget.querySelectorAll(this.rowSelectorValue).length)
  }
}
